/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { defineMessages } from 'react-intl';
import { BasicModal, BasicModalProps } from 'src/core/components/BasicModal';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { withModalMounter } from 'src/core/utils/hocs/withModalMounter';

const messages = defineMessages({
    title: { id: 'modelDeploy.swapDeploymentsModal.title', defaultMessage: 'Swap deployment names' },
    subtitle: {
        id: 'modelDeploy.swapDeploymentsModal.subtitle',
        defaultMessage: 'By swapping, you will swap the deployed models inside the deployment name'
    }
});

export const SwapDeploymentsModal = withModalMounter((props: BasicModalProps<{}>) => {
    const { localize } = useLocalization();

    return <BasicModal {...props} valid dialogContentProps={{ title: localize(messages.title), subText: localize(messages.subtitle) }} />;
});
